import { MixpanelProvider, useMixpanelContext } from './context.client'

export const MixpanelClient = {
  Provider: MixpanelProvider,
  use: useMixpanelContext,
}
